import PageIcon from "@/main/components/svg/pageIcon";
import { FILE_TYPES, FileType } from "../fileConfig";
import * as S from "../styles";

interface IDefaultPreviewProps {
	fileType: FileType;
	fileExtension?: string;
}

export const DefaultPreview: React.FC<IDefaultPreviewProps> = ({ fileType, fileExtension }) => {
	const baseConfig = FILE_TYPES[fileType];

	return (
		<S.Container>
			<PageIcon />
			<S.NameFile $backgroundColor={baseConfig.color}>{fileExtension?.toUpperCase() || baseConfig.label}</S.NameFile>
		</S.Container>
	);
};
